import LinkStatus from './LinkStatus';
import LinkedAccounts from './LinkedAccounts';
import ProviderInfo from './ProviderInfo';

export const components = {
  ProviderInfo,
  LinkStatus,
  LinkedAccounts,
};
